// const color3 = "#ff3333"; // #1d6810
// const color2 = "#713333";
// const color1 = "#1d6810"; //1d6810
const color3 = "#ff4560"; // "#ff4560"
const color2 = "#775dd0"; // "#feb019" 8a6100
const color1 = "#00e396"; // "#775dd0"
// "#00E396", "#FF4560", "#FEB019", "#775DD0"
export { color3, color2, color1 };
